import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import CommonStyles from '../CommonStyles';
import { withStyles } from '@mui/styles';
import { TRPL_SELECT_PLACEHOLDER } from '../../constants';
import Checkbox from '@mui/material/Checkbox';
import { CHECKBOX_ALL } from '../ChatContainer/components/Contacts';

const styles = {
  firstChildsContainer: {
    display: 'flex',
    padding: '0 10px',
    flexDirection: 'column',
    justifyContent: 'center',
    width: 'calc(100% - 34px)',
  },
  cropTextWithEllipsis: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
  },
  checkbox: {
    padding: 0,
    marginRight: '3px',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  ...CommonStyles,
};

export default withStyles(styles)(
  ({
    ref,
    title,
    style,
    value,
    values,
    margin,
    classes,
    multiple,
    disabled,
    onChange,
    MenuProps,
    placeholder,
    firstChilds,
    defaultValue,
    addEmptyItem,
    selectClasses,
    iconComponent,
    stylesToItems,
    complicatedValues,
    formControlStyles,
    disabledItemsIndexes,
    formControlClassName,
    disalbeItalicPlaceholder,
  }) => {
    const valuesCopy = values && [...values];
    if (addEmptyItem && valuesCopy && valuesCopy.length) valuesCopy.unshift('');

    const selectClassNames = selectClasses ? 
      {
        root: `${selectClasses.root} ${
        (((value === TRPL_SELECT_PLACEHOLDER || placeholder) && (value === undefined || value === null || value === '')) ||
        (value === placeholder))
          ? classes.selectPlaceholderItalic
          : ''
        }`
      }
    :
      {
        select: classes.trplSelect,
        icon: classes.trplSelectIcon,
        root: `${classes.trplSelectContainer} ${
          ((value === TRPL_SELECT_PLACEHOLDER || (value === placeholder)) && !disalbeItalicPlaceholder)
            ? classes.selectPlaceholderItalic
          : ((value === TRPL_SELECT_PLACEHOLDER || placeholder) && (value === undefined || value === null || value === ''))
            ? classes.selectPlaceholderItalic
            : ''
        }`,
      };

    const menuProps = {
      classes: {
        paper: classes.trplSelectMenu,
      },
      sx: {
        '& .MuiMenu-paper': {
          backgroundColor: '#fff',
        },
        '& .MuiMenuItem-root:hover': {
          backgroundColor: '#E3E1F0',
        },
        '& .Mui-selected': {
          backgroundColor: '#D9D8ED !important',
        }
      },
      ...MenuProps,
    };

    const itemStyles = {
      minHeight: '23px',
      lineHeight: 'normal',
      fontSize: 12,
      padding: '0 16px',
    };

    const selectValue = value || value === '' || value === false || value === 0 ? value : placeholder ? placeholder : '';

    const specialValStyle = stylesToItems && selectValue && stylesToItems[selectValue] ? stylesToItems[selectValue] : {};

    return (
      <FormControl
        fullWidth
        disabled={disabled}
        style={{ ...formControlStyles, ...specialValStyle }}
        margin={margin || 'normal'}
        className={formControlClassName}
      >
        {title ? <InputLabel className={classes.trplSelectLabel}>{title}</InputLabel> : null}

        <Select
          fullWidth
          ref={ref}
          style={style}
          value={selectValue}
          disableunderline='true'
          multiple={multiple}
          onChange={onChange}
          MenuProps={menuProps}
          classes={{ select: selectClassNames.root }}
          defaultValue={defaultValue}
          IconComponent={iconComponent}
          renderValue={(selected) => {
            if (multiple) {
              return (
                <div className={classes.cropTextWithEllipsis}>
                  {placeholder ? (
                    <span>{placeholder}</span>
                  ) : selected.includes(CHECKBOX_ALL) ? (
                    <span>All</span>
                  ) : selected.length ? (
                    selected.map((value, index) => {
                      const selectedValue = values.find(v => v.value === value);
                      if (selectedValue) return <span key={index}>{`${selectedValue.title}${index < selected.length - 1 ? ', ' : ''}`}</span>;
                      return 'none';
                    })
                  ) : null}
                </div>
              );
            } else {
              if (placeholder === selected) return placeholder;
              if (selected === TRPL_SELECT_PLACEHOLDER) return TRPL_SELECT_PLACEHOLDER;

              let selectedStr = typeof selected !== 'string' ? '' + selected : selected;
              if (complicatedValues) {
                for (let i = 0; i < values.length; i++) {
                  let val = typeof values[i].value !== 'string' ? '' + values[i].value : values[i].value;
                  if (val === selectedStr) return values[i].title;
                }
              } else {
                return selected;
              }
            }
          }}
        >
          {firstChilds ? <div className={classes.firstChildsContainer}>{firstChilds}</div> : null}

          {placeholder && (!multiple || (value && value[0] === TRPL_SELECT_PLACEHOLDER)) ? (
            <MenuItem
              disabled
              value={TRPL_SELECT_PLACEHOLDER}
              style={{
                ...itemStyles,
              }}
            >
              {placeholder}
            </MenuItem>
          ) : null}

          {valuesCopy && valuesCopy.map((val, index) => {
            const disabled = disabledItemsIndexes && disabledItemsIndexes.includes(index);

            const valueStyle = val && val.style ? val.style : {};
            const checkboxBGColor = multiple ? { backgroundColor: 'white' } : {};

            const specialValStyle = stylesToItems && stylesToItems[val] ? stylesToItems[val] : {};

            let menuItemStyles = { ...itemStyles, ...valueStyle, ...checkboxBGColor, ...specialValStyle };

            return (
              <MenuItem
                key={index}
                style={menuItemStyles}
                value={complicatedValues ? val.value : val}
                disabled={complicatedValues ? val.disabled : disabled}
              >
                {multiple && (
                  <Checkbox
                    size='small'
                    color='default'
                    checked={value.indexOf(val.value) > -1}
                    className={classes.checkbox}
                  />
                )}
                {complicatedValues ? val.title : val}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  }
);
